import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

import {style} from '../../../components/pdf/fontstyles';
import {AutoText} from '../../../components/pdf/autoText'; 

const styles = StyleSheet.create({

  paragraphRow: {
    flexDirection: 'row',
    marginBottom: 8,
    alignItems: 'flex-start',
  },
  number: {
    width: '5%', // reserve small width for number
    fontWeight: 'bold',
  },
  content: {
    width: '95%', // rest for content
    textAlign: 'justify',
  },
  signatureRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 30,
  },
});

const PensionFormBPart3 = ({ result }) => (
  
  <View size="A4" style={style.page}>
     <Text style={[style.title, style.ArialBold]}>PART - III</Text>

    {/* 1 */}
    <View style={styles.paragraphRow}>
      <Text style={styles.number}>1)</Text>
      <Text style={styles.content}>
        (Forward to the Audit Officer here indicate the address and designation) With the marks that.{"\n"}
        i) the particulars furnished by the applicant in Part – I have been verified and are correct.{"\n"}
        ii) The applicant is eligible to get a fraction of his pension commuted without medical examination.
      </Text>
    </View>

    {/* 2 */}
    <View style={styles.paragraphRow}>
      <Text style={styles.number}>2)</Text>
      <Text style={styles.content}>
        The commuted value of pension determined with reference to the table applicable at present comes to: Rs. 
        {Math.round(result.commutedPension * 12 * result.calculation[0].commutationFactor)}/-.
        The amount of residuary Pension after commutation will be Rs. {result.pension - result.commutedPension}/-.
      </Text>
    </View>

    {/* 3 */}
    <View style={styles.paragraphRow}>
      <Text style={styles.number}>3)</Text>
      <Text style={styles.content}>
        It is requested that further action to authorize the payment of the amount of commuted value of Pension may be taken as per rule 15 of the Maharashtra Civil Services (Commutation of Pension) Rules 1981.
      </Text>
    </View>

    {/* 4 */}
    <View style={styles.paragraphRow}>
      <Text style={styles.number}>4)</Text>
      <Text style={styles.content}>
        The receipt part I of the form has been acknowledged in part II which has been forwarded separately to the applicant No.
      </Text>
    </View>

    {/* 5 */}
    <View style={styles.paragraphRow}>
      <Text style={styles.number}>5)</Text>
      <Text style={styles.content}>
        The commuted value of Pension is debitable to head of Account.
      </Text>
    </View>

    {/* Place and Signature */}
     <View style={[styles.signatureRow, {marginTop: 50}]}>
         <Text>Place: {result.placeOfRetirement}</Text>
         <Text style={style.signature}>Head of Office</Text>
       </View>

    <Text style={{ marginTop: 10 }}>Date:</Text>

  </View>
);

export default PensionFormBPart3;
